import React from 'react';
import { Col, Modal, Row, Spin, Tag } from 'antd';
import { Field } from 'redux-form';
import { SelectField, TextAreaField, TextField } from 'redux-form-antd';
import Barcode from 'react-barcode';
import isEmpty from 'lodash/isEmpty';
import UploadDialog from '../../molecules/UploadDialog';
import { CheckboxField } from '../../../services/ant-redux';
import FormValueSelector from '../../../containers/FormValueSelector';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

// Priorities.
const categories = [
  { value: 1, label: 'Baby' },
  { value: 2, label: 'Electronics' },
  { value: 3, label: 'Beauty' },
  { value: 4, label: 'Beverages' },
  { value: 5, label: 'Bread and Bakery' },
  { value: 6, label: 'Breakfast and Cereal' },
  { value: 7, label: 'Condiments and Spices' },
  { value: 8, label: 'Cookies, Snacks, and Candy' },
  { value: 9, label: 'Dairy, Eggs, and Cheese' },
  { value: 10, label: 'Deli, Meats and Seafood' },
  { value: 11, label: 'Frozen Foods' },
  { value: 12, label: 'Health and Pharmacy' },
  { value: 13, label: 'Toys' },
  { value: 14, label: 'Books and Magazines' },
  { value: 15, label: 'Apparel and Footwear' },
  { value: 16, label: 'Paper, Cleaning, and Home' },
  { value: 17, label: 'Personal Care' },
  { value: 18, label: 'Pet Care' },
  { value: 19, label: 'Other' },
  { value: 1023, label: 'Automotive' },
  { value: 1024, label: 'Produce' },
  { value: 2213, label: 'Grains and Pasta' },
].sort((a, b) => a.label.localeCompare(b.label));

const alcoholTargeting = [
  { label: 'No targeting', value: 'null' },
  { label: 'Beer under 3.2%', value: 102 },
  { label: 'Beer over 3.2%', value: 103 },
  { label: 'Wine', value: 104 },
  { label: 'Liquor/Distilled Spirits', value: 105 },
];

const upcSensitivity = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
];

const ProductFormModal = ({
  currentCodes,
  isEdit,
  handleSubmit,
  submitting,
  visible,
  onCancel,
  activeInhand,
  loading,
}) => (
  <Modal
    confirmLoading={submitting}
    onCancel={onCancel}
    onOk={handleSubmit}
    width={800}
    okText={isEdit ? 'Update' : 'Create'}
    title={
      isEdit ? (
        <>Update Product {activeInhand.product_id && <Tag>ID {activeInhand.product_id}</Tag>}</>
      ) : (
        'New Product'
      )
    }
    visible={visible}
  >
    <Spin spinning={loading}>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col span={11}>
            <Field {...formItemLayout} label="Product Name" name="name" component={TextField} />
            <Field
              {...formItemLayout}
              label="Description Text"
              name="descr"
              component={TextAreaField}
            />
            <Field
              {...formItemLayout}
              name="cat_id"
              format={a => (!a ? null : `${a}`)}
              label="Category"
              component={SelectField}
              options={categories}
              placeholder="Select Category"
            />
            <Field
              {...formItemLayout}
              label="UPC Codes"
              name="upc_codes"
              component={TextAreaField}
            />
            <Field
              {...formItemLayout}
              label="UPC Sensitivity"
              disabled={isEmpty(currentCodes)}
              name="prefix_len"
              extra={isEmpty(currentCodes) && 'Enter UPC Codes to enable this field'}
              component={SelectField}
              options={upcSensitivity}
            />
            <Field
              {...formItemLayout}
              name="alcohol_type_id"
              format={a => (!a ? 'null' : `${a}`)}
              label="Alcohol Targeting"
              component={SelectField}
              options={alcoholTargeting}
              placeholder="Select Targeting"
            />
            <Field {...formItemLayout} label="Age 21+?" name="min_age" component={CheckboxField} />
          </Col>
          <Col span={11} offset={2}>
            <Field
              name="url_image"
              action={`${process.env.REACT_APP_INMARKET_API}/advertiser-ad/product/upload`}
              component={UploadDialog}
              type="input"
            />
            <FormValueSelector fieldName="upc_codes">
              {codes =>
                codes && (
                  <Barcode
                    style={{ width: '100%', margin: '0 auto' }}
                    width={1}
                    height={50}
                    value={codes && codes.split(',')[0]}
                  />
                )
              }
            </FormValueSelector>
          </Col>
        </Row>
      </form>
    </Spin>
  </Modal>
);

export default ProductFormModal;
